// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { v4 } from 'uuid';
const amplifyUuid = v4;
export { amplifyUuid };
